import type { Person } from "@/repositories/people/types";
import type { Plan } from "@/repositories/plan/types";
import { hasExcludeMandatoryPermission } from "@/utils/people";
import { hasActivePaidPlan } from "@/utils/plan-utils";

export function shouldExcludeOneTimePurchases(
  person: Pick<Partial<Person>, "permissions"> | null | undefined
): boolean {
  return hasExcludeMandatoryPermission(person);
}

export function shouldExcludePaidFeatures(
  person: Pick<Partial<Person>, "permissions"> | null | undefined,
  plan: Plan | null
): boolean {
  if (!hasExcludeMandatoryPermission(person)) {
    return false;
  }

  return !hasActivePaidPlan(plan);
}
